// import AWS from 'aws-sdk';

export const s3DOConfig = {
  // endpoint: new AWS.Endpoint(process.env.REACT_APP_AWS_DO_DIR_NAME || ''),
  endpoint: process.env.REACT_APP_AWS_DO_DIR_NAME,
  accessKeyId: process.env.REACT_APP_AWS_DO_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_DO_ACCESS_KEY,
  region: 'fra1',
  bucketName: process.env.REACT_APP_AWS_DO_BUCKET,
};
